import './ViewLabel.scss';
import { DeleteViewButton } from './DeleteViewButton';
import { EditFilled } from '@ant-design/icons';
import React from 'react';
import { RenameView } from './RenameView';
import { ShareViewButton } from './ShareViewButton';
import { Space } from 'antd';
import { UpdateViewButton } from './UpdateViewButton';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { useBoolean, useCurrentUser, useFeatureFlag } from '@hooks';
export const ViewLabel = ({ queryParams, view }) => {
    const canShare = useFeatureFlag(FeatureFlag.EmbeddedDataDictionary);
    const [isEditing, setIsEditing] = useBoolean(false);
    const { isReadOnly } = useCurrentUser();
    if (isEditing) {
        return React.createElement(RenameView, { onCancel: setIsEditing.off, onFinish: setIsEditing.off, view: view });
    }
    const { id, name } = view;
    return (React.createElement(Space, { className: 'view-label' },
        !isReadOnly && React.createElement(UpdateViewButton, { queryParams: queryParams, view: view }),
        React.createElement("span", null, name),
        !isReadOnly &&
            React.createElement(React.Fragment, null,
                canShare &&
                    React.createElement(ShareViewButton, { className: 'view-label-action', existingSharedKey: view.sharedKey, viewId: id }),
                React.createElement(EditFilled, { className: 'view-label-action view-label-edit', onClick: (e) => {
                        e.stopPropagation();
                        setIsEditing.on();
                    } }),
                React.createElement(DeleteViewButton, { className: 'view-label-action', viewId: id }))));
};
